export enum PortfolioTitle {
    All = "All",
    Mobile = "Mobile App",
    Web = "Web App",
    DeepLearning = "Deep Learning",
}
